import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Empty, Button, Form, Select, Icon, InputNumber, Input, Popconfirm } from 'antd'
import { infoRequired, validateAgencia, validateNumeroBanco } from '../../../utils/validators'
import { gerarRenovacaoTotal } from '../../../redux-flow/actions/contratos'
import moment from 'moment'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { maskAgenciaOnChange, maskContaOnChange } from '../../../utils/masks';
import { planos } from '../../../constants'
import bancos from '../../Contratos/FormContrato/bancos'

const Option = Select.Option

const NoContracts = () => (
    <Empty description="Nenhum contrato encontrado">
    </Empty>
)

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class FormRenovacaoTotal extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            valorInput: 0,
            showInput: false,
            isSuccess: false,
            readOnly: true
        }
    }

    handleClick = e => {
        this.setState({
            showInput: true,
            readOnly: false
        })
    }

    changeInput = e => {
        this.setState({
            valorInput: e
        })
    }

    refreshPage() {
        setTimeout(function () {
            window.location.reload()
        }, 5000)
    }

    render() {
        // Utilizar a props CONTRATO***
        const { form, handleSubmit, tipo, isLoading, contratos, contrato, userid, message } = this.props
        //let success = this.props.success
        const dateValue = contrato.dataInicio
        const endDateValue = contrato.dataFim
        const codigoBanco = contrato.codigoBanco
        const nomeBanco = contrato.nomeBanco
        const numeroAgencia = contrato.numeroAgencia
        const numeroConta = contrato.numeroConta
        const codigoNomeBanco = [codigoBanco, nomeBanco].join(' - ')
        const codigoNomeBancoSeparado = codigoNomeBanco.split(' - ')
        const valorRenovacaoNovo = Number(contrato.Renovacaos[0].valorRenovacao)
        const status = contrato.status
        let success =  this.props.success
        return (
            /*contrato.length > 0 ? (*/
                success ? (
                    <div className="finishedSignup">
                        <div>
                            <Row>
                                <Col md={7} style={{ margin: 'auto' }}>
                                    <div>
                                        <h4 className="tx-pink" style={{ textAlign: 'center' }}><b>Pedido de Renovação Enviado!</b></h4><br />
                                        <p style={{ textAlign: 'center', fontSize: '12px' }}>
                                            Enviamos o seu contrato para o email cadastrado em nossa plataforma. Verifique na sua caixa de entrada, assine e anexe na plataforma.<br />
                                        </p><br />
                                        <Button className="btnGrafico"  onClick={() => { this.props.closeModal() }} style={{ width: '30%', height: '36px', display: 'flex', margin: 'auto', alignItems: 'center', justifyContent: 'center' }}>Fechar</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                ) : (
                    <Form className="formContrato" layout="vertical" onSubmit={handleSubmit(form, contrato.status, userid, Number(contrato.ValorContratos[0].valorDia), contrato.id, contrato.duracao)}>
                        {
                            !success && message != '' ? (
                                <div class="alert alert-danger fade show notificacao-status">
                                    <p className="mb-0">{message}</p>
                                </div> ) : ''
                        }
                        <h4 className="renovacaoTitle">Você optou pela renovação total!</h4><br />
                        <p>Confirme seus dados bancários para seu pedido de renovação</p>
                        <Row>

                        <Col md={12}>
                            <p className="tx-pink"><b>Contrato vencido</b></p>
                    </Col>
                    <Col md={4}>
                            <div>
                                <p className="tx-pink">Produto de Investimento</p>
                                <p>{tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA FI')}</p>
                                <p style={{ visibility: tipo === 6 ? 'hidden' : '' }}>
                                    {tipo === 6 ? '' : contrato.duracao} meses
                                </p>
                            </div>
                        </Col>
                        <Col md={4}>
                            <p className="tx-pink">Valor do contrato</p>
                            <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(contrato.ValorContratos[0].valorDia)).replace('R$', '')}</p>
                            {/* <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorRenovacao).replace('R$', '')}</p> */}
                        </Col>
                        <Col md={4}>
                            <p className="tx-pink">Data final do contrato</p>
                            <p>{moment(String(endDateValue)).format('DD/MM/YYYY')}</p>
                        </Col>
                        <hr style={{ width: '90%' }} />
                            <Col md={12}>
                                <p className="tx-pink"><b>Contrato novo</b></p>
                            </Col>
                            <Col md={4}>
                                <div>
                                    <p className="tx-pink">Produto de Investimento</p>
                                    <p>{tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA FI')}</p>
                                    <p style={{ visibility: tipo === 6 ? 'hidden' : '' }}>
                                        {tipo === 6 ? '' : planos[contrato.Renovacaos[0].tipoContratoRenovacao]['meses']} meses
                                    </p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <p className="tx-pink">Valor da Renovação</p>
                                <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorRenovacaoNovo).replace('R$', '')}</p>
                            </Col>
                            <Col md={4}>
                                <p className="tx-pink">Data da Renovação</p>
                                <p>{moment().format('DD/MM/YYYY')}</p>
                            </Col>
                            <hr style={{ width: '90%' }} />
                            <Col md={12}>
                                <p className="tx-pink"><b>Dados Bancários</b></p>
                            </Col>
                                <>
                                    <Col md={4}>
                                        <Form.Item label="Banco e código">
                                            {form.getFieldDecorator('codigoBanco', {
                                                rules: [infoRequired],
                                                initialValue: codigoNomeBanco
                                            })(
                                                <Select
                                                    showSearch
                                                    disabled={this.state.readOnly}
                                                >
                                                    {bancos.map(banco => (
                                                        <Option value={banco.name}>{banco.name}</Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Item label="Agência Bancária (sem dígito)">
                                            {form.getFieldDecorator('agencia', {
                                                rules: [ infoRequired, validateAgencia() ],
                                                initialValue: numeroAgencia
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="0000"
                                                    onKeyPress={maskAgenciaOnChange}
                                                    disabled={this.state.readOnly}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Item label="Número da Conta (com dígito)">
                                            {form.getFieldDecorator('conta', {
                                                rules: [ infoRequired, validateNumeroBanco()],
                                                initialValue: numeroConta
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="00000-0"
                                                    onKeyPress={maskContaOnChange}
                                                    onChange={maskContaOnChange}
                                                    disabled={this.state.readOnly}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <div></div>
                                    <br />
                                </>
                        </Row>
                        <div>
                        </div>
                        <Form.Item>
                            {isLoading ? <LoadingComponent /> :
                            <div>
                                <button 
                                    disabled={isLoading} 
                                    className="btnGrafico" 
                                    type="submit" 
                                    style={{ 
                                        width: '25%', 
                                        float: 'right', 
                                        position: 'relative', 
                                        marginLeft: '20px' 
                                    }} 
                                    >
                                    Confirmar
                                </button>
                                <Button
                                    className="btnGraficoRenovacao"
                                    style={{
                                        float: 'right',
                                        position: 'relative',
                                        fontWeight: 'bold', 
                                        width: '15%' 
                                    }}
                                    onClick={this.handleClick}
                                >
                                    Editar
                                </Button>
                            </div> }
                        </Form.Item>
                    </Form>
                )
           /* ) : <NoContracts />*/
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    message: state.contratos.message,
    userid: state.login.userid,
    contratos: state.contratos.contratos,
    values: state.contratos.values
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, status, idCliente, valorRenovacao, idContrato, duracao) => e => {
        e.preventDefault()
        //dispatch(gerarResgate(form, idContrato, tipo, userId))
        dispatch(gerarRenovacaoTotal(form, status, idCliente, valorRenovacao, idContrato, duracao))
    }
})

export default Form.create({ name: 'create-renovacao-total' })(
    connect(mapStateToProps, mapDispatchToProps)(FormRenovacaoTotal)
)